import cx from 'classnames';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

import s from './popover.module.scss';

type PopoverProps = ComponentPropsWithoutRef<'div'>;

const Popover = forwardRef<HTMLDivElement, PopoverProps>(
  ({ children, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cx(s['popoverContainer'], className)}
      contentEditable={false}
      onMouseDown={(e) => {
        // prevent toolbar from taking focus away from editor
        e.preventDefault();
        props.onMouseDown?.(e);
      }}
      {...props}
    >
      {children}
    </div>
  ),
);
Popover.displayName = 'Popover';

export { Popover };
